export default __webpack_public_path__ + "static/media/arrow.b55658b3.svg";